import { render, staticRenderFns } from "./TabelaChecklist.vue?vue&type=template&id=cfa73924&"
import script from "./TabelaChecklist.vue?vue&type=script&lang=js&"
export * from "./TabelaChecklist.vue?vue&type=script&lang=js&"
import style0 from "./TabelaChecklist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports